<template>

	<!--	:name="vpEtikett"-->
	<!-- '#default' nedan = 'v-slot:default' = nya sättet att sätta 'slot-scope' och kallas 'slot props' (slotProps): -->
	<validation-provider ref="validationProvider"
		tag="div"
		mode="eagerMedBlurOchDebounce"
		:rules="vpValidationRules"
		#default="{ valid, errors, failedRules, flags }"
		class="_eui-form_kryssruta_validation-provider"
	>
		<div
			class="_eui-form_kryssruta"
			:class="[ vpClass, {
				'-obligatorisk':arRequired && !vpIndikeraInteObligatorisk,
				'-readonly':vpReadOnly,
				'-osynlig':skaVaraOsynlig,
				'-invalid':flags.validated && !valid,
			}]"
			:style="vpStyle"
		>


	<!--<input ref="inputelementet"
	:id="uniktId"
	:type="vpInputType"
	:placeholder="vpPlaceholder"
	v-model="innerChecked"
	:disabled="skaVaraInaktiverad"
	:autofocus="vpAutofocus"
	v-bind="$attrs"
	v-on="$listeners"

	:value="value"
	@input="$emit('input', $event.target.value)"

	>-->

	<!--	:checked="vpPaslagen" @change="onChange" >
	:checked="innerChecked"
	@change="onChange"

	@input.stop.prevent
	@change.stop.prevent="onChange"
	v-bind="$attrs"
	v-on="$listeners"
	:checked="vpChecked"
				:name="vpInputName"
				:value="uniktId + '-value'"
				:value="vpChecked"
				:value="validationValue"
				:value="vpChecked"
				:checked="vpChecked"

	-->
	<!--	:title="vpTooltip"-->
	<!--	v-model="innerChecked"-->

			<!-- Se kommentar vid computed nedan:
				... Now the <base-input> component is a fully transparent wrapper, meaning it can be used exactly like a normal <input> element: all the same attributes and listeners will work, without the .native modifier.
			-->
			<!--	:value="value"-->



			<!--
				– VeeValidate: The fields being validated *must have a v-model* so the component can correctly identify the element/component being validated.
				– To make the model update when the change event occurs, and not any time the user presses a key, you can use v-model.lazy instead of just v-model. Nedan v-model-binder vi alltså till "modellen" innerChecked, change:
			-->
			<input ref="inputelementet"
				:id="uniktId"
				type="checkbox"
				:name="uniktId + '-name'"
				:title="vpTooltip"
				:autofocus="vpAutofocus"
				:disabled="skaVaraInaktiverad || vpReadOnly"
				:class="{
					'-readonly':vpReadOnly,
				}"
				@keydown.enter="onEnterTryckt()"
				@keydown.esc="onEscTryckt()"

				v-model.lazy="innerChecked"

				v-bind="$attrs"
				v-on="inputListeners"
			>

	<!-- <label
	:for="uniktId"
	class="_eui-form_kryssruta_etikett"
	:class="{
		fore:true,
	}"
	:style="{ width:vpEtikettbreddMedEnhet }"
	v-html="vpEtikett + ':'"
	></label>-->

	<!--	:title="vpTooltip"-->
	<!--
	@click.stop.prevent="$emit('input', !this.value);"
				@click.stop.prevent="onChange"
	-->
			<!-- + '&nbsp;'"-->
			<label
				:for="uniktId"
				class="_eui-form_kryssruta_etikett"
				:class="{
					'-readonly':vpReadOnly,
				}"
			>
				<span v-if="vpEtikett" v-html="vpEtikett"></span>
				<slot></slot>

				<!-- Negativ top-/botten-marginal för att knappen ska kunna vara lite högre än vad raden egentligen pallar i höjd: -->
				<!-- vp-color = CssEgenskaper.TextfärgLänk: -->
				<!-- För att underlätta ochg slippa hantera dessa kombinatuioner, döljs hjälpknappen alltid om kryssrutan är skaVaraInaktiverad || vpReadOnly. Det är *kanske* inte helt optimalt: -->
				<eui-hjalpknapp v-if="vpHjalptextHtml && !skaVaraInaktiverad && !vpReadOnly"
					:vp-unikt-id-del="uniktId"
					vp-color="#0088dd"
					style="
						margin: -2em 0;
					"
				>
					<div v-html="vpHjalptextHtml"></div>
				</eui-hjalpknapp>

			</label>

			<!--<transition name="el-zoom-in-left">-->
			<div class="_eui-form_kryssruta_feltext">
				<div class="ellipsis" v-html="errors[0]">
					<!--{{ errors[0] }}-->
				</div>
			</div>
			<!--</transition>-->

		</div>
	</validation-provider>
</template>



<script>
//#####################################################################################

	import Vue from 'vue';
	import { euiLifecycleStatusesMixin } from 'v-mixins/euiLifecycleStatusesMixin';

	import euiHjalpknapp from 'v-components/euiHjalpknapp.vue';

	import { ValidationProvider } from 'vee-validate';

	import VeeValidateInstanceMedRattOptions from 'VeeValidateInstanceMedRattOptions';
	VeeValidateInstanceMedRattOptions.runOnce();		// Kör funktionen om den inte redan körts!

	// Gemensam för alla sådana här komponenter på en sida, vilket är precis det vi vill:
	let uniktIdCounter = 0;


	export default {

		name: 'eui-form-kryssruta',

		mixins: [ euiLifecycleStatusesMixin ],

		components: {
			euiHjalpknapp,
			'validation-provider': ValidationProvider,
		},

		model: {
			// use `vpChecked` as the prop which take the place of `value`. This allows using the `value` prop for a different purpose:
			// Obs! Går emot rekommendation på https://blog.webf.zone/vue-js-forms-components-and-considerations-d81b3ffe9efb!
			prop: 'vpChecked',
			event: 'change'
		},

		props:
		{
			// use `vpChecked` as the prop which take the place of `value`. This allows using the `value` prop for a different purpose:
			vpChecked: {
				type: Boolean,
				default: false,
			},
			//value: {
			//	type: String,
			//	default: 'eui-form-kryssruta-unikt-' + (uniktIdCounter + 1) + '-value',
			//},

			//vpInputName: {		// Blir name-attributet på inputen och även key i FormData.
			//	type: String,
			//	required: true
			//},

			vpAutofocus: {
				type: Boolean,
				default: false,
			},

			vpEtikett: {			// Får innehålla HTML.
				type: String,
				default: null,
			},
			//vpEtikettbreddMedEnhet: {
			//	type: String,
			//	default: '20%',
			//},

			vpHjalptextHtml: {
				type: String,
				default: null,			// undefined/null => ingen hjälpknapp visas efter (sist i) label.
			},

			vpIndikeraInteObligatorisk: {
				type: Boolean,
				default: false,
			},

			vpValidationRules: {
				type: [Object,String],
				default: '',
			},

			vpAccessKey: {
				type: String,
				default: null
			},
			vpTooltip: {
				type: String,			// Får innehålla HTML.
				default: null
			},

			vpReadOnly: {
				type: Boolean,
				default: false,
			},
			vpInaktiverad: {
				type: Boolean,
				default: false,
			},
			vpOsynlig: {
				type: Boolean,
				default: false,
			},

			vpClass: {
				type: String,
				default: null
			},
			vpStyle: {
				type: String,
				default: null
			},
		},

		data() {
			return {
				uniktId: 'eui-form-kryssruta-unikt-' + (++uniktIdCounter),
				innerChecked: false,
			};
		},

		// https://vuejs.org/v2/guide/components-custom-events.html#Binding-Native-Events-to-Components:
		// ...In that case, the .native listener in the parent would silently break. There would be no errors, but the onFocus handler wouldn’t be called when we expected it to.
		//
		// To solve this problem, Vue provides a $listeners property containing an object of listeners being used on the component. For example:
		// {
		// 	focus: function (event) { /* ... */ }
		// 	input: function (value) { /* ... */ },
		// }
		//
		// Using the $listeners property, you can forward all event listeners on the component to a specific child element with v-on="$listeners". For elements like <input>, that you also want to work with v-model, it’s often useful to create a new computed property for listeners, like inputListeners below:
		//
		// Vue.component('base-input', {
		// 	inheritAttrs: false,
		// 	props: ['label', 'value'],
		// 	computed: {
		// 		inputListeners: function () {
		// 		var vm = this
		// 		// `Object.assign` merges objects together to form a new object
		// 		return Object.assign({},
		// 			// We add all the listeners from the parent
		// 			this.$listeners,
		// 			// Then we can add custom listeners or override the
		// 			// behavior of some listeners.
		// 			{
		// 				// This ensures that the component works with v-model
		// 				input: function (event) {
		// 				vm.$emit('input', event.target.value)
		// 				}
		// 			}
		// 		)
		// 		}
		// 	},
		// 	template: `
		// 		<label>
		//				{{ label }}
		// 			<input
		// 				v-bind="$attrs"
		// 				v-bind:value="value"
		//					v-on="inputListeners"
		// 			>
		// 		</label>
		// 	`
		// })
		//
		// Now the <base-input> component is a fully transparent wrapper, meaning it can be used exactly like a normal <input> element: all the same attributes and listeners will work, without the .native modifier:

		inheritAttrs: false,		// Attribut på komponenten ärvs inte till själva *komponentens* rot-element, utan ist till input-elementet, se template ovan. (Gäller *inte* class- och style-attributen!)

		computed: {

			inputListeners() {
				//var vm = this;

				// `Object.assign` merges objects together to form a new object
				return Object.assign({},

					// We add all the listeners from the parent
					this.$listeners,

					// Then we can add custom listeners or override the
					// behavior of some listeners.
					{
						// This (these?!) ensures that the component works with v-model. (Detta gäller inte riktigt längre, då vi inte längre emittar rätt värde.):

						//// Denna behövs inte längre då vi bytt till egen model. Ersätts med hantering av 'change' nedan:
						//input(event) {
						//	console.log('Input event: checked/value:', event.target.checked, event.target.value);
						//	//vm.$emit('input', event.target.checked);	//(event.target.checked ? 'on' : ''));
						//	//vm.innerChecked = event.target.checked;
						//	//event.preventDefault();
						//	//event.stopPropagation();
						//},

						// Enda syftet med denna är att förhindra Vues interna hantering av v-model, dvs att eventet change initierar att värdet, som i komponenters eventhanterare är *själva eventet*, inte event.value eller, som i fallet med kryssruta, event.checked, uppåt.
						// Dock verkar det inte förhindra vee-validate att initiera en validering då detta inträffar (initierat av eventet Input.Change??). Vid just den valideringen använder vee-validate av oklar anledning input-elementets .value (string, som alltid är "on" om man inte satt ngt annat). Vi filtrerar därför för det i egna regeln 'required-checked' som kan användas ist.f. standardregler:
						change(event) {
							//console.log('Change event: checked/value:', event.target.checked, event.target.value);

							// Denna emit görs istället i watch:innerChecked:
							//vm.$emit('change', event.target.checked);

							// Den felaktiga vee-validate-valideringen enl kommentar ovan förhindras *inte* av dessa:
							//event.preventDefault();
							//event.stopPropagation();
						},
					}
				);
			},

			//validationValue() {
			//	return (this.innerChecked ? 'one' : 'two');
			//},

			arRequired() {
				return (!this.vpReadOnly && !this.skaVaraInaktiverad && !!this.vpValidationRules && !!(this.vpValidationRules.indexOf('required') !== -1));
			},

			skaVaraOsynlig() {
				return (this.vpOsynlig || !this.lifecycleStatuses.mixinMountedHasOccured);
			},
			skaVaraInaktiverad() {
				return (this.vpInaktiverad || !this.lifecycleStatuses.mixinMountedHasOccured);
			},
		},

		watch: {
			// Handles internal model changes.
			innerChecked(nyttVarde, tidigareVarde) {
				// Obs! Denna watch triggas *inte* vid initial rendering med värdet true!
				this.$emit('change', nyttVarde);
			},

			// Handles external model changes.
			vpChecked(nyttVarde, tidigareVarde) {
				// Obs! Denna watch triggas *inte* vid initial rendering med värdet true!
				this.innerChecked = nyttVarde;
			},

			vpReadOnly(nyttVarde, tidigareVarde)
			{
				if (!nyttVarde)
				{
					// Om den ändrats från read-only –> ändringsbar:
					// Sätt ev autofocus:
					this.sattEventuellAutofocus();
				}
			},
		},

		methods: {

			onEnterTryckt() {
				this.$emit('enter-tryckt');
			},

			onEscTryckt() {
				this.$emit('esc-tryckt');
			},

			// Denna hantering är endast till för att förhindra att kryssrutan får focus vid klick (men får det vid tabbning):
			// Todo: Obs! .stop.prevent på denna ovan gör att vee-validate sätts ur spel. Den är tydligen beroende av native events??
			// Dock har det funkat klockrent med validering vid sådant här klick tidigare! Undrar vad jag ändrat i logiken sedan dess (ledtråd: en massa, både här och i valideringsregeln 'required-checked')?
			// Det verkar som om validatorn anropas korrekt, med korrekta värden, men att vee-validate struntar i resultatet. Jag noterade att i detta case är webbläsarens kryssruta *inte* ändrad än vid valideringen (vilket inte borde spela ngt roll, tycker jag). Den ändras i detta case först efteråt, reaktivt. I övriga typer av hantering av togglingar så är det nog tvärtom; vi låter webbläsaren göra sitt och sedan reagerar vi på den ändringen/eventet.
			// Problemet verkar vara att någon "initial"/tidigare validering inte skett (flaggan validated = false). Så här ser flaggorna ut i det fallet:
			// {"untouched":true,"touched":false,"dirty":false,"pristine":true,"valid":false,"invalid":true,"validated":false,"pending":false,"required":false,"changed":false}
			// Om bara en tidigare validering skett (ex tangentbordets mellanslag) är flaggan satt och *då* funkar vidare togglingar med musen!
			// (Det räcker alltså inte att validerings-regel-koden körs och returnerar false för att felet ska visas. Dessutom verkar inte rätt message vara satt i flagg-fallet ovan.)
			// Provar att gå runt genom att nedan tvinga en manuell validering vid varje klick (även om värdena måhända inte är rätt satta än!):
			// Funkade inte som tänkt. Första gången ok, men inte 2-n:
			// Kopplar ur hela skiten ist!
			//onChange(event) {
			//	// Se kommentar ovan:
			//	//this.$refs.validationProvider.validate();

			//	this.innerChecked = !this.innerChecked;
			//}

			sattEventuellAutofocus()
			{
				// Sätt ev autofocus:
				if (this.vpAutofocus)
				{
					// Invänta, så att ev reaktiva ändringar (här, att inputelementet blir fokuserbart) hinner slå igenom först:
					Vue.nextTick(function () {
							this.$refs.inputelementet
								.focus();
						}
						, this	// Vue.nextTick 'this' context.
					);
				}
			},
		},



		//== Lifecycle hooks  ================================================================================================================

		created() {
			this.innerChecked = this.vpChecked;
		},

		mounted() {

			this.$nextTick(function () {
				// Sätt ev autofocus:
				this.sattEventuellAutofocus();
			});
		},

	}
</script>
